<template>
  <div class="rating-stars">
    <div class="star-wrapper" v-for="star in starsLimit" :key="star">
      <svg
        v-if="star <= rating"
        xmlns="http://www.w3.org/2000/svg"
        width="15"
        height="14"
        viewBox="0 0 15 14"
        fill="none"
      >
        <path
          d="M6.93186 1.00798C7.18132 0.56539 7.81868 0.565389 8.06814 1.00798L9.73397 3.96345C9.82703 4.12857 9.98733 4.24503 10.1731 4.28252L13.4987 4.95352C13.9967 5.05401 14.1937 5.66017 13.8498 6.03419L11.5538 8.53178C11.4255 8.67131 11.3643 8.85975 11.386 9.04803L11.7755 12.4182C11.8339 12.9229 11.3182 13.2975 10.8563 13.0861L7.77141 11.6742C7.59907 11.5953 7.40093 11.5953 7.22859 11.6742L4.14373 13.0861C3.68175 13.2975 3.16612 12.9229 3.22445 12.4182L3.61395 9.04803C3.63571 8.85975 3.57449 8.67131 3.44621 8.53178L1.15016 6.03419C0.806317 5.66017 1.00327 5.05401 1.50129 4.95352L4.82688 4.28252C5.01267 4.24503 5.17297 4.12857 5.26603 3.96345L6.93186 1.00798Z"
          fill="#FFA500"
        />
      </svg>
      <svg
        v-else
        xmlns="http://www.w3.org/2000/svg"
        width="15"
        height="14"
        viewBox="0 0 15 14"
        fill="none"
      >
        <path
          d="M6.93186 1.00798C7.18132 0.56539 7.81868 0.565389 8.06814 1.00798L9.73397 3.96345C9.82703 4.12857 9.98733 4.24503 10.1731 4.28252L13.4987 4.95352C13.9967 5.05401 14.1937 5.66017 13.8498 6.03419L11.5538 8.53178C11.4255 8.67131 11.3643 8.85975 11.386 9.04803L11.7755 12.4182C11.8339 12.9229 11.3182 13.2975 10.8563 13.0861L7.77141 11.6742C7.59907 11.5953 7.40093 11.5953 7.22859 11.6742L4.14373 13.0861C3.68175 13.2975 3.16612 12.9229 3.22445 12.4182L3.61395 9.04803C3.63571 8.85975 3.57449 8.67131 3.44621 8.53178L1.15016 6.03419C0.806317 5.66017 1.00327 5.05401 1.50129 4.95352L4.82688 4.28252C5.01267 4.24503 5.17297 4.12857 5.26603 3.96345L6.93186 1.00798Z"
          fill="#F0F2F5"
        />
      </svg>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    starsLimit: {
      type: Number,
      default: 5,
    },
    rating: {
      type: Number,
      default: 0,
    },
  },
}
</script>
